/**
 * Type definitions for authentication module
 */

/**
 * OAuth tokens stored in localStorage after token exchange
 */
export interface OAuthCredentials {
	/** Access token for API authentication */
	token: string
	/** Refresh token for token renewal */
	refreshToken: string
}

/**
 * Configuration for cookie storage of JWT token
 */
export interface CookieConfig {
	/** Secure flag (default: true - HTTPS only) */
	secure?: boolean
	/** SameSite attribute (default: 'Strict') */
	sameSite?: "Strict" | "Lax" | "None"
	/** Cookie path (default: '/') */
	path?: string
	/** Cookie max age in seconds (optional, set by server) */
	maxAge?: number
}

/**
 * Default cookie configuration
 */
export const DEFAULT_COOKIE_CONFIG: Required<Omit<CookieConfig, "maxAge">> = {
	secure: true,
	sameSite: "Strict",
	path: "/",
} as const

/**
 * Cookie name for JWT token
 */
export const AUTH_TOKEN_COOKIE_NAME = "token" as const

/**
 * localStorage keys for OAuth tokens
 */
export const OAUTH_TOKEN_KEYS = {
	ACCESS_TOKEN: "access_token",
	REFRESH_TOKEN: "refresh_token",
} as const

export const USER_ID_KEY = "user_id" as const
